<template>
	<div
		class="g-block-divider-thick g-block-divider-padding"
		:class="{
			'g-block-divider-thick--edit': editable,
			'is-active': editable && active,
			'g-block-divider-thick--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-thick__line"
			:style="{ background: themeColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerThick',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-thick {
		.divider-block-edit-shell();
	}

	.g-block-divider-thick__line {
		display: block;
		width: 100%;
		height: 3px;
	}

	.g-block-divider-thick--h5 {
		.g-block-divider-thick__line {
			height: 0.06rem;
		}
	}
</style>
